import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Snippet = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 3c0-.83.67-1.5 1.5-1.5h2a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h2a.5.5 0 0 1 0 1H3A1.5 1.5 0 0 1 1.5 13V3Zm2.75 2.5c0-.28.22-.5.5-.5h6.5a.5.5 0 0 1 0 1h-6.5a.5.5 0 0 1-.5-.5Zm0 2.5c0-.28.22-.5.5-.5h6.5a.5.5 0 0 1 0 1h-6.5a.5.5 0 0 1-.5-.5Zm.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM13 14.5c.83 0 1.5-.67 1.5-1.5V3c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 0 0 0 1h2c.28 0 .5.22.5.5v10a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2Z"
      />
    </svg>
  )
})

export default Snippet
